import type { NotificationData } from "@mantine/notifications";

export const defaultNotificationOptions: Partial<NotificationData> = {
  position: "top-right",
  autoClose: 3000,
  withCloseButton: false
};
